import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-plus-locked',
  templateUrl: './plus-locked.component.html',
  styleUrls: ['./plus-locked.component.scss']
})
export class PlusLockedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
